/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-04-24T14:03:07.281Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '26.1.10601-2246349';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};